const getUser = () => {
  return JSON.parse(localStorage.getItem('userInfo'))
}

const checkPermissions = (permissions) => {
  const user = getUser()
  return user.permissions.some(permission => permissions.includes(permission))
}

const checkRoles = (roles) => {
  const user = getUser()
  return user.roles.some(role => roles.includes(role))
}

export { checkPermissions, checkRoles, getUser }
